import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import DefaultLayout from '../layouts/default';

import RootEventListener from '../components/rootEventListener';
import ModalContainer from '../components/modal';
import SidebarContainer from '../components/sidebar';
import PopupContainer from '../components/popup';
import SheetContainer from '../components/sheet';
import HeaderContainer from '../components/header';
import BottomNavibarContainer from '../components/bottomNavibar';

import CardIndex from '../pages/cards/index';
import ModelIndex from '../pages/models/index';
import ModelIntro from '../pages/models/intro';
import PaymentIndex from '../pages/payments/index';
import PostingIndex from '../pages/postings/index';
import PostingShow from '../pages/postings/show';
import PostingFeedback from '../pages/postings/feedback';
import GuideIndex from '../pages/settings/guide';
import BrandIndex from '../pages/settings/brand';
import PasswordIndex from '../pages/settings/password';
import AlarmIndex from '../pages/settings/alarm';

import ProductIndex from '../pages/products/index';

import CampaignIndex from '../pages/campaigns/index';
import CampaignForm from 'pages/campaigns/campaignForm/campaignForm';
import CampaignComplete from '../pages/campaigns/complete';
import CampaignShow from '../pages/campaigns/show';
import CampaignIntro from '../pages/campaigns/intro';
import CampaignPaymentsV1 from '../pages/campaigns/payments/v1/index';
import CampaignPayments from '../pages/campaigns/payments/index';

import LookbookIndex from '../pages/lookbook/index';

import SNSIndex from '../pages/sns/index/index';
import SNSShow from '../pages/sns/show/index';
import SNSCreate from '../pages/sns/create/index';
import SNSPaymentComplete from '../pages/sns/payments/complete';
import SNSIntro from '../pages/sns/intro/index';
import SNSPayments from '../pages/sns/payments/index';
import SNSPostingOrderUpdate from '../pages/sns/order/postings';
// import SNSBrandReview from "../pages/sns/brand_review"
import SNSCelebDetail from '../pages/sns/brand_review/celeb/detail';
import SNSOrderCeleb from '../pages/sns/brand_review/celeb/order';
import SNSUploadCeleb from '../pages/sns/brand_review/celeb/upload';
import SNSYoutubeDetail from '../pages/sns/brand_review/youtube/detail';
import SNSOrderYoutube from '../pages/sns/brand_review/youtube/order';
import SNSUploadYoutube from '../pages/sns/brand_review/youtube/upload';
import SNSVideoDetail from '../pages/sns/brand_review/video/detail';
import SNSOrderVideo from '../pages/sns/brand_review/video/order';
import SNSUploadVideo from '../pages/sns/brand_review/video/upload';

import InviteIntro from '../pages/invite/intro';
import InfluencersShow from '../pages/influencers/show';

import ReportIndex from '../pages/reports/index';
import AuthIndex from '../pages/auth/index';
import ModelActivityWeeklyIndex from '../pages/charts/modelActivityWeekly';
import ModelActivityApprovedWeeklyIndex from '../pages/charts/modelActivityApprovedAt';
import MissionsIndex from '../pages/help/missions';

import RentalIntro from '../pages/rental/intro';
import RentalIndex from '../pages/rental/index';
import RentalAmbassadorIndex from '../pages/rental/ambassador/index';
import RentalAmbassadorPreviewIndex from '../pages/rental/ambassador/preview';
import RentalRequirementsBasic from '../pages/rental/ambassador/requirements/basic';
import RentalAmbassadorRequirementsPosting from '../pages/rental/ambassador/requirements/posting';
import RentalAmbassadorRequirementsVideo from '../pages/rental/ambassador/requirements/video';
import RentalPaymentsIndex from '../pages/rental/payments/index';
import BlankPage from '../pages/blank/index';
import LectureIndex from '../pages/lecture/index';
import LectureLessonIndex from '../pages/lecture/lesson/index';
import LectureChapterIndex from '../pages/lecture/chapter/index';
import TransactionInfoIndex from '../pages/transaction-info/index';

import GuidelineMigrationIndex from '../pages/dev/guideline-migration/index';
import GuidelineMigrationSeedingPosting from '../pages/dev/guideline-migration/seeding/posting';
import GuidelineMigrationSeedingVideo from '../pages/dev/guideline-migration/seeding/video';
import GuidelineMigrationAmbassadorPosting from '../pages/dev/guideline-migration/ambassador/posting';
import GuidelineMigrationAmbassadorVideo from '../pages/dev/guideline-migration/ambassador/video';
import BRAND from '../constants/brand';
import store from 'store/store';
import { APP_LOCALE, initLanguage } from '@languages/index';
import { LOCALES } from 'constants/locales';

import DownloadDesktopAppIndex from 'pages/download-desktop-app';
import { setPreferences } from 'store/preference/actions';

export const ROUTES = {
  DOWNLOAD_DESKTOP_APP_INDEX: {
    PATH: '/',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: DownloadDesktopAppIndex,
  },

  AUTH_INDEX: {
    PATH: '/',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: AuthIndex,
  },

  RENTAL_INDEX: {
    PATH: '/rental',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: RentalIndex,
  },

  RENTAL_AMBASSADOR_INDEX: {
    PATH: '/rental/ambassadors',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: RentalAmbassadorIndex,
  },

  RENTAL_AMBASSADOR_PREVIEW_INDEX: {
    PATH: '/rental/ambassadors/preview',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: RentalAmbassadorPreviewIndex,
  },

  RENTAL_REQUIREMENTS_BASIC: {
    PATH: '/rental/ambassador/requirements/basic',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: RentalRequirementsBasic,
  },

  RENTAL_AMBASSADOR_REQUIREMENTS_POSTING: {
    PATH: '/rental/ambassador/requirements/posting',
    header: false,
    LAYOUT: DefaultLayout,
    SCREEN: RentalAmbassadorRequirementsPosting,
  },

  RENTAL_AMBASSADOR_REQUIREMENTS_VIDEO: {
    PATH: '/rental/ambassador/requirements/video',
    header: false,
    LAYOUT: DefaultLayout,
    SCREEN: RentalAmbassadorRequirementsVideo,
  },

  RENTAL_PAYMENTS_INDEX: {
    PATH: '/rental/payments',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: RentalPaymentsIndex,
  },

  RENTAL_INTRO: {
    PATH: '/rental/intro',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: RentalIntro,
  },

  PRODUCT_INDEX: {
    PATH: '/products',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: ProductIndex,
  },

  CAMPAIGN_INDEX: {
    PATH: '/campaigns',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignIndex,
  },

  CAMPAIGN_CREATE: {
    PATH: '/campaigns/create',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignForm,
  },

  CAMPAIGN_UPDATE: {
    SHOW: (campaignId: string) => {
      return `/campaigns/update/${campaignId}`;
    },
    PATH: '/campaigns/update/:campaignId',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignForm,
  },

  CAMPAIGN_COMPLETE: {
    PATH: '/campaigns/complete',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignComplete,
  },

  CAMPAIGN_PRODUCT_SHOW: {
    SHOW: (campaignId, productId) => {
      return `/campaigns/${campaignId}/product/${productId}`;
    },
    PATH: '/campaigns/:campaignId/product/:productId',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignShow,
  },

  CAMPAIGN_INTRO: {
    PATH: '/campaigns/intro',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignIntro,
  },

  CAMPAIGN_PAYMENTS_INDEX: {
    PATH: '/campaigns/payments',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignPayments,
  },

  CAMPAIGN_PAYMENTS_V1_INDEX: {
    PATH: '/campaigns/payments/v1',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CampaignPaymentsV1,
  },

  LOOKBOOK_INDEX: {
    PATH: '/lookbook',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: LookbookIndex,
  },

  SNS_INDEX: {
    PATH: '/sns',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSIndex,
  },

  SNS_CELEB_DETAIL: {
    PATH: '/sns/celebrities/detail/:celebId',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSCelebDetail,
  },
  SNS_ORDER_CELEB: {
    PATH: '/sns/celebrities/order',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSOrderCeleb,
  },
  SNS_UPLOAD_CELEB: {
    PATH: '/sns/celebrities/upload',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSUploadCeleb,
  },

  SNS_YOUTUBE_DETAIL: {
    PATH: '/sns/youtubes/detail/:id',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSYoutubeDetail,
  },
  SNS_ORDER_YOUTUBE: {
    PATH: '/sns/youtubes/order',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSOrderYoutube,
  },
  SNS_UPLOAD_YOUTUBE: {
    PATH: '/sns/youtubes/upload',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSUploadYoutube,
  },

  SNS_VIDEO_DETAIL: {
    PATH: '/sns/videos/detail/:id',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSVideoDetail,
  },
  SNS_ORDER_VIDEO: {
    PATH: '/sns/videos/order',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSOrderVideo,
  },
  SNS_UPLOAD_VIDEO: {
    PATH: '/sns/videos/upload',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSUploadVideo,
  },

  SNS_SHOW: {
    SHOW: (postingId) => {
      return `/sns/postings/${postingId}`;
    },
    PATH: '/sns/postings/:postingId',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSShow,
  },

  SNS_CREATE: {
    PATH: '/sns/postings/create',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSCreate,
  },

  SNS_UPDATE: {
    UPDATE: (postingId) => {
      return `/sns/postings/${postingId}/update`;
    },
    PATH: '/sns/postings/:postingId/update',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSCreate,
  },

  SNS_PAYMENT_COMPLETE: {
    PATH: '/sns/payment/complete',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSPaymentComplete,
  },

  SNS_INTRO: {
    PATH: '/sns/intro',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSIntro,
  },

  SNS_PAYMENTS_INDEX: {
    PATH: '/sns/payment',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSPayments,
  },

  SNS_POSTING_ORDER: {
    PATH: '/sns/postings/order',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: SNSPostingOrderUpdate,
  },

  MODEL_INDEX: {
    PATH: '/models',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: ModelIndex,
  },

  MODEL_INTRO: {
    PATH: '/models/intro',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: ModelIntro,
  },

  CARD_INDEX: {
    PATH: '/cards',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: CardIndex,
  },

  PAYMENT_INDEX: {
    PATH: '/payments',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: PaymentIndex,
  },

  INVITE_INTRO: {
    PATH: '/invite/intro',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: InviteIntro,
  },

  INFLUENCER_PAGE: {
    PATH: '/influencers',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: InfluencersShow,
  },

  POSTING_INDEX: {
    PATH: '/postings',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: PostingIndex,
  },

  POSTING_SHOW: {
    PATH: '/postings/:id',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: PostingShow,
  },

  POSTING_FEEDBACK: {
    PATH: '/postings/:id/feedback',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: PostingFeedback,
  },

  SETTINGS_BRAND_GUIDE: {
    PATH: '/settings/guide',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: GuideIndex,
  },

  SETTINGS_BRAND_INDEX: {
    PATH: '/settings/brand',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: BrandIndex,
  },

  SETTINGS_BRAND_ALARM: {
    PATH: '/settings/brand/alarm',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: AlarmIndex,
  },

  SETTINGS_BRAND_PASSWORD: {
    PATH: '/settings/brand/password',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: PasswordIndex,
  },

  REPORT_INDEX: {
    PATH: '/reports',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: ReportIndex,
  },

  CHART_MODELS_WEEKLY_ACTIVITY: {
    PATH: '/chart/models/activity/weekly',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: ModelActivityWeeklyIndex,
  },

  CHART_MODELS_APPROVED_AT: {
    PATH: '/chart/models/approved/weekly',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: ModelActivityApprovedWeeklyIndex,
  },

  HELP_MISSIONS: {
    PATH: '/help/missions',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: MissionsIndex,
  },

  DEV_GUIDELINE_MIGRATION: {
    PATH: '/dev/guideline-migration',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: GuidelineMigrationIndex,
  },

  DEV_GUIDELINE_MIGRATION_SEEDING_POSTING: {
    MAKEPATH: (brandId, campaignId) => {
      return `/dev/guideline-migration/seeding/posting?brandId=${brandId}&campaignId=${campaignId}`;
    },
    PATH: '/dev/guideline-migration/seeding/posting',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: GuidelineMigrationSeedingPosting,
  },

  DEV_GUIDELINE_MIGRATION_SEEDING_VIDEO: {
    MAKEPATH: (brandId, campaignId) => {
      return `/dev/guideline-migration/seeding/video?brandId=${brandId}&campaignId=${campaignId}`;
    },
    PATH: '/dev/guideline-migration/seeding/video',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: GuidelineMigrationSeedingVideo,
  },

  DEV_GUIDELINE_MIGRATION_AMBASSADOR_POSTING: {
    MAKEPATH: (brandId) => {
      return `/dev/guideline-migration/ambassador/posting?brandId=${brandId}`;
    },
    PATH: '/dev/guideline-migration/ambassador/posting',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: GuidelineMigrationAmbassadorPosting,
  },

  DEV_GUIDELINE_MIGRATION_AMBASSADOR_VIDEO: {
    MAKEPATH: (brandId) => {
      return `/dev/guideline-migration/ambassador/video?brandId=${brandId}`;
    },
    PATH: '/dev/guideline-migration/ambassador/video',
    HEADER: false,
    LAYOUT: DefaultLayout,
    SCREEN: GuidelineMigrationAmbassadorVideo,
  },

  LECTURE_INDEX: {
    PATH: '/lectures',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: LectureIndex,
  },

  LECTURE_LESSON_INDEX: {
    SHOW: (lectureId) => {
      return `/lectures/${lectureId}/lessons`;
    },
    PATH: '/lectures/:lectureId/lessons',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: LectureLessonIndex,
  },

  LECTURE_CHAPTER_INDEX: {
    SHOW: (lectureId, lessonId, chapterId) => {
      return `/lectures/${lectureId}/${lessonId}/${chapterId}`;
    },
    PATH: '/lectures/:lectureId/:lessonId/:chapterId',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: LectureChapterIndex,
  },

  TRANSACTION_INFO_INDEX: {
    PATH: '/transaction-info',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: TransactionInfoIndex,
  },

  JAPAN: {
    PATH: 'https://glovv.co.kr/japan',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: () => {
      return <></>;
    },
  },

  BLANK_PAGE: {
    PATH: '/blank',
    HEADER: true,
    LAYOUT: DefaultLayout,
    SCREEN: BlankPage,
  },
};

const Router = (props: any) => {
  const isAuthInitialized = useSelector((state: any) => state.auth.auth.token);
  const isBrandInitialized = useSelector((state: any) => state.brand.brand.id);

  const isLectureOnlyAccount = useSelector((state: any) => BRAND.isLectureOnlyBrand(state.brand.brand.id));

  const isWholesale = useSelector((state: any) => {
    return (
      state.brand.brand.businessType === BRAND.BUSINESS_TYPE.WHOLESALE ||
      window.location.hostname.split('.')[0] === 'wholesale'
    );
  });

  const isAuthenticated = isAuthInitialized && isBrandInitialized;

  const Page = (props: any) => {
    const Screen = (PROPS: any) => {
      return (
        <React.Fragment>
          <PROPS.SCREEN.LAYOUT header={PROPS.SCREEN.HEADER}>
            <PROPS.SCREEN.SCREEN />
          </PROPS.SCREEN.LAYOUT>
        </React.Fragment>
      );
    };

    return <Screen {...props} />;
  };

  const locale = store.getState()?.preferences?.preferences?.locale ?? process.env.LOCALE ?? LOCALES.KO;

  initLanguage(locale);

  const queryParams = new URLSearchParams(window.location.search);
  const client = queryParams.get('client');
  const storedClient = store.getState()?.preferences?.preferences?.client;

  useEffect(() => {
    if (client && client != storedClient) {
      store.dispatch(
        setPreferences({
          client: client,
        }),
      );
    }
  }, [client]);

  const isDesktop = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  if (
    true || // 임시
    isDesktop() == false || // 모바일 접속
    APP_LOCALE == LOCALES.JA || // 일본 접속
    (client && client == 'desktop') || // 데스크탑 접속
    (storedClient && storedClient == 'desktop') || // 데스크탑 접속
    isWholesale // 도매 브랜드 접속
  ) {
    return (
      <>
        <HeaderContainer />

        {isAuthenticated ? (
          <Routes>
            {isLectureOnlyAccount && <Route path={'/'} element={<Page SCREEN={ROUTES.LECTURE_INDEX} />} />}

            <Route path={ROUTES.RENTAL_INDEX.PATH} element={<Page SCREEN={ROUTES.RENTAL_INDEX} />} />
            <Route path={ROUTES.RENTAL_INTRO.PATH} element={<Page SCREEN={ROUTES.RENTAL_INTRO} />} />
            <Route path={ROUTES.PRODUCT_INDEX.PATH} element={<Page SCREEN={ROUTES.PRODUCT_INDEX} />} />
            <Route path={ROUTES.CAMPAIGN_INDEX.PATH} element={<Page SCREEN={ROUTES.CAMPAIGN_INDEX} />} />
            <Route path={ROUTES.CAMPAIGN_CREATE.PATH} element={<Page SCREEN={ROUTES.CAMPAIGN_CREATE} />} />
            <Route path={ROUTES.CAMPAIGN_UPDATE.PATH} element={<Page SCREEN={ROUTES.CAMPAIGN_UPDATE} />} />
            <Route path={ROUTES.CAMPAIGN_COMPLETE.PATH} element={<Page SCREEN={ROUTES.CAMPAIGN_COMPLETE} />} />
            <Route path={ROUTES.CAMPAIGN_PRODUCT_SHOW.PATH} element={<Page SCREEN={ROUTES.CAMPAIGN_PRODUCT_SHOW} />} />
            <Route path={ROUTES.CAMPAIGN_INTRO.PATH} element={<Page SCREEN={ROUTES.CAMPAIGN_INTRO} />} />
            <Route
              path={ROUTES.CAMPAIGN_PAYMENTS_INDEX.PATH}
              element={<Page SCREEN={ROUTES.CAMPAIGN_PAYMENTS_INDEX} />}
            />
            <Route
              path={ROUTES.CAMPAIGN_PAYMENTS_V1_INDEX.PATH}
              element={<Page SCREEN={ROUTES.CAMPAIGN_PAYMENTS_V1_INDEX} />}
            />
            <Route path={ROUTES.LOOKBOOK_INDEX.PATH} element={<Page SCREEN={ROUTES.LOOKBOOK_INDEX} />} />
            <Route path={ROUTES.SNS_INTRO.PATH} element={<Page SCREEN={ROUTES.SNS_INTRO} />} />
            <Route path={ROUTES.SNS_INDEX.PATH} element={<Page SCREEN={ROUTES.SNS_INDEX} />} />

            <Route path={ROUTES.SNS_CELEB_DETAIL.PATH} element={<Page SCREEN={ROUTES.SNS_CELEB_DETAIL} />} />
            <Route path={ROUTES.SNS_ORDER_CELEB.PATH} element={<Page SCREEN={ROUTES.SNS_ORDER_CELEB} />} />
            <Route path={ROUTES.SNS_UPLOAD_CELEB.PATH} element={<Page SCREEN={ROUTES.SNS_UPLOAD_CELEB} />} />

            <Route path={ROUTES.SNS_YOUTUBE_DETAIL.PATH} element={<Page SCREEN={ROUTES.SNS_YOUTUBE_DETAIL} />} />
            <Route path={ROUTES.SNS_ORDER_YOUTUBE.PATH} element={<Page SCREEN={ROUTES.SNS_ORDER_YOUTUBE} />} />
            <Route path={ROUTES.SNS_UPLOAD_YOUTUBE.PATH} element={<Page SCREEN={ROUTES.SNS_UPLOAD_YOUTUBE} />} />

            <Route path={ROUTES.SNS_VIDEO_DETAIL.PATH} element={<Page SCREEN={ROUTES.SNS_VIDEO_DETAIL} />} />
            <Route path={ROUTES.SNS_ORDER_VIDEO.PATH} element={<Page SCREEN={ROUTES.SNS_ORDER_VIDEO} />} />
            <Route path={ROUTES.SNS_UPLOAD_VIDEO.PATH} element={<Page SCREEN={ROUTES.SNS_UPLOAD_VIDEO} />} />

            <Route path={ROUTES.SNS_SHOW.PATH} element={<Page SCREEN={ROUTES.SNS_SHOW} />} />
            <Route path={ROUTES.SNS_CREATE.PATH} element={<Page SCREEN={ROUTES.SNS_CREATE} />} />
            <Route path={ROUTES.SNS_UPDATE.PATH} element={<Page SCREEN={ROUTES.SNS_UPDATE} />} />
            <Route path={ROUTES.SNS_PAYMENTS_INDEX.PATH} element={<Page SCREEN={ROUTES.SNS_PAYMENTS_INDEX} />} />
            <Route path={ROUTES.SNS_POSTING_ORDER.PATH} element={<Page SCREEN={ROUTES.SNS_POSTING_ORDER} />} />
            <Route path={ROUTES.SNS_PAYMENT_COMPLETE.PATH} element={<Page SCREEN={ROUTES.SNS_PAYMENT_COMPLETE} />} />

            <Route path={ROUTES.INVITE_INTRO.PATH} element={<Page SCREEN={ROUTES.INVITE_INTRO} />} />
            <Route path={ROUTES.INFLUENCER_PAGE.PATH} element={<Page SCREEN={ROUTES.INFLUENCER_PAGE} />} />
            <Route path={ROUTES.MODEL_INDEX.PATH} element={<Page SCREEN={ROUTES.MODEL_INDEX} />} />
            <Route path={ROUTES.MODEL_INTRO.PATH} element={<Page SCREEN={ROUTES.MODEL_INTRO} />} />

            <Route path={ROUTES.CARD_INDEX.PATH} element={<Page SCREEN={ROUTES.CARD_INDEX} />} />

            <Route path={ROUTES.PAYMENT_INDEX.PATH} element={<Page SCREEN={ROUTES.PAYMENT_INDEX} />} />

            <Route path={ROUTES.POSTING_SHOW.PATH} element={<Page SCREEN={ROUTES.POSTING_SHOW} />} />
            <Route path={ROUTES.POSTING_INDEX.PATH} element={<Page SCREEN={ROUTES.POSTING_INDEX} />} />
            <Route path={ROUTES.POSTING_FEEDBACK.PATH} element={<Page SCREEN={ROUTES.POSTING_FEEDBACK} />} />

            <Route path={ROUTES.SETTINGS_BRAND_GUIDE.PATH} element={<Page SCREEN={ROUTES.SETTINGS_BRAND_GUIDE} />} />
            <Route path={ROUTES.SETTINGS_BRAND_INDEX.PATH} element={<Page SCREEN={ROUTES.SETTINGS_BRAND_INDEX} />} />
            <Route path={ROUTES.SETTINGS_BRAND_ALARM.PATH} element={<Page SCREEN={ROUTES.SETTINGS_BRAND_ALARM} />} />

            <Route
              path={ROUTES.SETTINGS_BRAND_PASSWORD.PATH}
              element={<Page SCREEN={ROUTES.SETTINGS_BRAND_PASSWORD} />}
            />
            <Route path={ROUTES.REPORT_INDEX.PATH} element={<Page SCREEN={ROUTES.REPORT_INDEX} />} />
            <Route
              path={ROUTES.CHART_MODELS_WEEKLY_ACTIVITY.PATH}
              element={<Page SCREEN={ROUTES.CHART_MODELS_WEEKLY_ACTIVITY} />}
            />
            <Route path={ROUTES.HELP_MISSIONS.PATH} element={<Page SCREEN={ROUTES.HELP_MISSIONS} />} />
            <Route
              path={ROUTES.RENTAL_AMBASSADOR_INDEX.PATH}
              element={<Page SCREEN={ROUTES.RENTAL_AMBASSADOR_INDEX} />}
            />
            <Route
              path={ROUTES.RENTAL_REQUIREMENTS_BASIC.PATH}
              element={<Page SCREEN={ROUTES.RENTAL_REQUIREMENTS_BASIC} />}
            />
            <Route
              path={ROUTES.RENTAL_AMBASSADOR_REQUIREMENTS_POSTING.PATH}
              element={<Page SCREEN={ROUTES.RENTAL_AMBASSADOR_REQUIREMENTS_POSTING} />}
            />
            <Route
              path={ROUTES.RENTAL_AMBASSADOR_REQUIREMENTS_VIDEO.PATH}
              element={<Page SCREEN={ROUTES.RENTAL_AMBASSADOR_REQUIREMENTS_VIDEO} />}
            />
            <Route path={ROUTES.RENTAL_PAYMENTS_INDEX.PATH} element={<Page SCREEN={ROUTES.RENTAL_PAYMENTS_INDEX} />} />
            <Route
              path={ROUTES.DEV_GUIDELINE_MIGRATION.PATH}
              element={<Page SCREEN={ROUTES.DEV_GUIDELINE_MIGRATION} />}
            />
            <Route
              path={ROUTES.DEV_GUIDELINE_MIGRATION_SEEDING_POSTING.PATH}
              element={<Page SCREEN={ROUTES.DEV_GUIDELINE_MIGRATION_SEEDING_POSTING} />}
            />
            <Route
              path={ROUTES.DEV_GUIDELINE_MIGRATION_SEEDING_VIDEO.PATH}
              element={<Page SCREEN={ROUTES.DEV_GUIDELINE_MIGRATION_SEEDING_VIDEO} />}
            />
            <Route
              path={ROUTES.DEV_GUIDELINE_MIGRATION_AMBASSADOR_POSTING.PATH}
              element={<Page SCREEN={ROUTES.DEV_GUIDELINE_MIGRATION_AMBASSADOR_POSTING} />}
            />
            <Route
              path={ROUTES.DEV_GUIDELINE_MIGRATION_AMBASSADOR_VIDEO.PATH}
              element={<Page SCREEN={ROUTES.DEV_GUIDELINE_MIGRATION_AMBASSADOR_VIDEO} />}
            />
            <Route path={ROUTES.BLANK_PAGE.PATH} element={<Page SCREEN={ROUTES.BLANK_PAGE} />} />
            <Route path={ROUTES.LECTURE_INDEX.PATH} element={<Page SCREEN={ROUTES.LECTURE_INDEX} />} />
            <Route path={ROUTES.LECTURE_LESSON_INDEX.PATH} element={<Page SCREEN={ROUTES.LECTURE_LESSON_INDEX} />} />
            <Route path={ROUTES.LECTURE_CHAPTER_INDEX.PATH} element={<Page SCREEN={ROUTES.LECTURE_CHAPTER_INDEX} />} />

            <Route
              path={ROUTES.TRANSACTION_INFO_INDEX.PATH}
              element={<Page SCREEN={ROUTES.TRANSACTION_INFO_INDEX} />}
            />

            <Route path="*" element={<Page SCREEN={ROUTES.CAMPAIGN_INDEX} />} />
          </Routes>
        ) : (
          <Routes>
            <Route
              path={ROUTES.CHART_MODELS_WEEKLY_ACTIVITY.PATH}
              element={<Page SCREEN={ROUTES.CHART_MODELS_WEEKLY_ACTIVITY} />}
            />

            <Route
              path={ROUTES.CHART_MODELS_APPROVED_AT.PATH}
              element={<Page SCREEN={ROUTES.CHART_MODELS_APPROVED_AT} />}
            />

            <Route
              path={ROUTES.RENTAL_AMBASSADOR_PREVIEW_INDEX.PATH}
              element={<Page SCREEN={ROUTES.RENTAL_AMBASSADOR_PREVIEW_INDEX} />}
            />

            <Route path={ROUTES.AUTH_INDEX.PATH} element={<Page SCREEN={ROUTES.AUTH_INDEX} />} />
            <Route path="*" element={<Page SCREEN={ROUTES.AUTH_INDEX} />} />
          </Routes>
        )}

        <SidebarContainer />
        <ModalContainer />
        <SheetContainer />
        <PopupContainer />
        <RootEventListener />
        <BottomNavibarContainer />
      </>
    );
  }

  return (
    <>
      <Routes>
        <Route
          path={ROUTES.DOWNLOAD_DESKTOP_APP_INDEX.PATH}
          element={<Page SCREEN={ROUTES.DOWNLOAD_DESKTOP_APP_INDEX} />}
        />

        <Route path="*" element={<Page SCREEN={ROUTES.DOWNLOAD_DESKTOP_APP_INDEX} />} />
      </Routes>

      <RootEventListener />
    </>
  );
};

export default Router;
